<template>
  <div class="feature-extra">
    <button
        type="button"
        class="feature-extra__tile"
        @click="showModal = true"
        v-b-modal="`feature-extra-${productFeature.id}`">
      <span class="feature-extra__icon">
        <b-icon icon="sliders"/>
      </span>
      <span class="feature-extra__copy">
        <strong>بیشتر</strong>
        <small>دسته و ترتیب</small>
      </span>
      <b-icon icon="chevron-left" class="feature-extra__chevron"/>
    </button>

    <b-modal
        v-if="showModal"
        @hide="onModalHide"
        :id="`feature-extra-${productFeature.id}`"
        hide-footer
        size="lg"
        title="تنظیمات بیشتر ویژگی"
        modal-class="feature-extra-modal"
        content-class="feature-extra-modal__content"
        header-class="feature-extra-modal__header"
        body-class="feature-extra-modal__body">
      <div dir="rtl" class="feature-extra-panel">
        <form class="feature-extra-panel__form" @submit.prevent="submitFeatureExtraChanges">
          <div class="feature-extra-panel__grid">
            <form-group class="feature-extra-panel__field" :validations="$v.featureExtraForm.category">
              <div slot-scope="{ errors }">
                <label for="feature-extra-category">
                  دسته‌بندی
                  <button
                      type="button"
                      class="feature-extra-panel__add"
                      v-b-modal="`create-feature-category-${productFeature.id}`">
                    <b-icon-plus-circle-fill/>
                  </button>
                </label>
                <select v-model="featureExtraForm.category" class="form-control custom-select">
                  <option v-for="category in featureCategories" :key="category.value" :value="category.value">
                    {{ category.text }}
                  </option>
                </select>
                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>

            <form-group class="feature-extra-panel__field" :validations="$v.featureExtraForm.item_order">
              <div slot-scope="{ errors }">
                <label for="feature-extra-item-order">ترتیب ویژگی</label>
                <input
                    v-model="featureExtraForm.item_order"
                    type="text"
                    class="form-control"
                    id="feature-extra-item-order">
                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>
          </div>

          <button class="feature-extra-panel__submit" variant="primary" type="submit">
            ثبت تغییرات
          </button>
        </form>

        <b-modal :id="`create-feature-category-${productFeature.id}`" hide-footer title="دسته جدید">
          <div dir="rtl" class="feature-extra-panel">
            <form @submit.prevent="createNewFeatureCategory">
              <form-group class="feature-extra-panel__field" :validations="$v.form.featureCategoryName">
                <div slot-scope="{ errors }">
                  <label>نام دسته‌بندی</label>
                  <input v-model="form.featureCategoryName" type="text" class="form-control">
                  <form-errors-manager :errors="errors"/>
                </div>
              </form-group>
              <button class="feature-extra-panel__submit" type="submit">ثبت دسته</button>
            </form>
          </div>
        </b-modal>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {required, numeric} from "vuelidate/lib/validators";
import FormGroup from "../../../validator/FormGroup.vue";
import FormErrorsManager from "../../../validator/FormErrorsManager.vue";

/*
* use showModal on data section to refresh component
* this refresh will effect the dom and make all checkbox have same value
*
* */

export default {
  name: "FeatureItemExtra",
  components: {
    FormGroup, FormErrorsManager,
  },
  props: {
    productFeature: {},
    product: {}
  },
  data() {
    return {
      form: {
        featureCategoryName: '',
      },
      featureExtraForm: {
        item_order: '',
        category: '',
      },
      showModal: false
    }
  },
  validations: {
    form: {
      featureCategoryName: {required},
    },
    featureExtraForm: {
      item_order: {required, numeric},
      category: {required},
    }
  },
  computed: {
    featureCategories() {
      let categories = []


      this.product.features.forEach((item) => {
        let itemCategory = item.extra.category
        categories.push({text: itemCategory, value: itemCategory})
      })

      let uniqueCategories = categories.filter((obj, index, self) =>
          index === self.findIndex((t) => t.text === obj.text && t.value === obj.value)
      );

      return uniqueCategories

    },
  },
  methods: {
    invalid() {
      this.$v.form.$touch();
      return !this.$v.form.$invalid;
    },
    invalidFeatureExtra() {
      this.$v.featureExtraForm.$touch();
      return !this.$v.featureExtraForm.$invalid;
    },
    createNewFeatureCategory() {
      if (this.invalid()) {
        this.productFeature.extra.category = this.form.featureCategoryName
        this.productFeature.extra.item_order = 1
        this.showModal = false
      }
    },
    submitFeatureExtraChanges() {
      if (this.invalidFeatureExtra()) {
        if (this.productFeature.feature.type == 'checkbox') {

          // find all checkbox in same group and update them
          this.product.features.forEach(item => {
            if (item.extra.group == this.productFeature.extra.group) {
              item.extra.category = this.featureExtraForm.category
              item.extra.item_order = parseInt(this.featureExtraForm.item_order)
            }
          })

        }
        this.productFeature.extra.category = this.featureExtraForm.category
        this.productFeature.extra.item_order = parseInt(this.featureExtraForm.item_order)
        this.showModal = false
        this.$forceUpdate()
      }
    },
    initComponent() {
      let productFeatureClone = this.productFeature.extra
      this.featureExtraForm.category = productFeatureClone.category
      this.featureExtraForm.item_order = productFeatureClone.item_order
    },
    onModalHide() {
      this.showModal = false
    }
  },
  updated() {
    this.initComponent()
  },
  mounted() {
    this.initComponent()
  }
}
</script>

<style scoped>
.feature-extra {
  min-width: 0;
  height: 100%;
}

.feature-extra__tile {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
  min-height: 100%;
  padding: 0.75rem 0.85rem;
  border: 1px dashed rgba(235, 61, 96, 0.35);
  border-radius: 12px;
  background:
      linear-gradient(135deg, rgba(235, 61, 96, 0.1), rgba(235, 61, 96, 0.02));
  color: #1e1e1e;
  text-align: right;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.feature-extra__tile:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(235, 61, 96, 0.12);
  background: rgba(235, 61, 96, 0.12);
}

.feature-extra__icon {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: var(--primary, #eb3d60);
  color: #fff;
  flex: 0 0 auto;
}

.feature-extra__copy {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
  flex: 1 1 auto;
}

.feature-extra__copy strong {
  font-size: 0.9rem;
  font-weight: 800;
}

.feature-extra__copy small {
  color: #6b6b6b;
  font-size: 0.75rem;
}

.feature-extra__chevron {
  color: #6b6b6b;
  flex: 0 0 auto;
}

.feature-extra-panel__form {
  display: grid;
  gap: 1rem;
}

.feature-extra-panel__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
}

.feature-extra-panel__field {
  padding: 0.85rem;
  border-radius: 14px;
  background: #f7f7f8;
  border: 1px solid rgba(30, 30, 30, 0.08);
}

.feature-extra-panel__field label {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.45rem;
  font-weight: 700;
  color: #424242;
}

.feature-extra-panel__add {
  border: 0;
  background: transparent;
  color: var(--primary, #eb3d60);
  padding: 0;
  cursor: pointer;
}

.feature-extra-panel__submit {
  min-height: 44px;
  border: 0;
  border-radius: 999px;
  background: var(--primary, #eb3d60);
  color: #fff;
  font-weight: 800;
  cursor: pointer;
  margin-top: 10px;
  padding: 10px;
}

@media (max-width: 767.98px) {
  .feature-extra-panel__grid {
    grid-template-columns: 1fr;
  }
}
</style>
